import { createSlice } from '@reduxjs/toolkit'

export const CampaignSearchFilterSlice = createSlice({
  name: 'campaign_search_filter',
  initialState: {
    value: '',
  },
  reducers: {
    updateSearchFilter: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { updateSearchFilter } = CampaignSearchFilterSlice.actions

export default CampaignSearchFilterSlice.reducer